import React from "react";
import { Select } from "antd";
import { FilterField, ToggleRow } from "./FilterShared";
import { JOB_FUNCTION_OPTIONS, SENIORITY_OPTIONS } from "./filterOptions";

const BASE_SELECT  = { style: { width: "100%" }, allowClear: true };
const TAG_SELECT   = { ...BASE_SELECT, mode: "tags", filterOption: false, tokenSeparators: [","] };
const MULTI_SELECT = { ...BASE_SELECT, mode: "multiple", showSearch: true };

const JobTitlePanel = ({
  values,
  set,
  titleInc,
  titleExc,
  hideAdvancedFields = false,
}) => {

  return (
    <div className="qp-filter-panel-body">
      <FilterField label="Job Title (Include)">
        <Select
          {...TAG_SELECT}
          showSearch
          placeholder="e.g. Software Engineer"
          onSearch={titleInc.onSearch}
          loading={titleInc.loading}
          options={titleInc.opts}
          value={values.jobTitleInclude}
          onChange={set("jobTitleInclude")}
          notFoundContent={titleInc.loading ? "Searching…" : "Type to search or add"}
        />
      </FilterField>

      {!hideAdvancedFields && (
      <FilterField label="Job Title (Exclude)">
        <Select
          {...TAG_SELECT}
          showSearch
          placeholder="e.g. Recruiter"
          onSearch={titleExc.onSearch}
          loading={titleExc.loading}
          options={titleExc.opts}
          value={values.jobTitleExclude}
          onChange={set("jobTitleExclude")}
          notFoundContent={titleExc.loading ? "Searching…" : "Type to search or add"}
        />
      </FilterField>
      )}

      {!hideAdvancedFields && (
        <FilterField>
          <ToggleRow
            leftLabel="Current titles only"
            leftChecked={values.currentTitlesOnly}
            onLeft={set("currentTitlesOnly")}
            rightLabel="Include related titles"
            rightChecked={values.includeRelatedTitles}
            onRight={set("includeRelatedTitles")}
          />
        </FilterField>
      )}

      {!hideAdvancedFields && (
        <FilterField label="Department">
          <Select
            {...MULTI_SELECT}
            placeholder="Select departments"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            value={values.jobFunction}
            onChange={set("jobFunction")}
            options={JOB_FUNCTION_OPTIONS.map((o) => ({ label: o.title, value: o.value }))}
          />
        </FilterField>
      )}

      {!hideAdvancedFields && (
        <FilterField label="Seniority">
          <Select
            {...MULTI_SELECT}
            placeholder="Select seniority levels"
            filterOption={(input, option) =>
              option.label.toLowerCase().includes(input.toLowerCase())
            }
            value={values.seniority}
            onChange={set("seniority")}
            options={SENIORITY_OPTIONS.map((o) => ({ label: o.title, value: o.value }))}
          />
        </FilterField>
      )}
    </div>
  );
};

export default JobTitlePanel;
